//
//
//
//
//
//
import MapApplication from "../../MapApplication";
export default {
  name: "index",
  data: function data() {
    return {
      mapID: 'test666'
    };
  },
  mounted: function mounted() {
    MapApplication.initMap(this);
  },
  destroyed: function destroyed() {
    MapApplication.destroyMap();
  }
};